// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".team-member-edit[data-v-36ac5cc4]{height:100%}.team-member-edit-tab[data-v-36ac5cc4]{flex:1;width:100%;overflow-x:hidden;overflow-y:auto}.team-member-edit-tab .lx-grid[data-v-36ac5cc4]{height:100% !important}.team-member-edit-divider[data-v-36ac5cc4]{width:100%;height:1px;background-color:rgba(0,0,0,.1)}", ""]);
// Exports
module.exports = exports;
